const languages = {

    web_title                       : '東方',
    

    account_userinfo_title          : '身份信息',   
    account_userinfo_subtitle_1     : '證件上傳',
    account_userinfo_subtitle_2     : '個人信息',

    please_select                   : '請選擇',
    please_input                    : '請輸入',
    please_wait                     : '請稍等...',

    name                            : '姓名',
    telephone                       : '手機號碼',
    gender                          : '性別',
    birthday                        : '出生日期',
    idcode                          : '身份證號',
    email                           : '郵箱',
    marriage                        : '婚姻狀態',
    verify_code                     : '驗證碼',

    male                            : '男',
    female                          : '女',

    marriage_1                      : '未婚',
    marriage_2                      : '已婚',

    send_verify_code                : '發送驗證碼',
    please_upload_id_pic            : '請上傳身份證正反面照片',
    shoot_fail                      : '拍攝失敗，請重試',
    verify_code_send_success        : '驗證碼發送成功',
    second                          : '秒',

    error_format_email              : '郵箱格式錯誤',

    next_step                       : '下一步',

    

    account_type_title              : '賬戶類型',
    account_type_1                  : '國内銀行賬戶',
    account_type_2                  : '海外銀行賬戶',
    account_type_3                  : 'USDT',

    account_bank_title              : '銀行卡信息',
    bank_upload                     : '銀行卡上傳',
    bank_account_info               : '銀行賬戶信息',
    open_bank                       : '開戶銀行',
    branch_bank                     : '所屬支行',
    bank_number                     : '銀行卡號',
    please_branch_bank              : '請以「XX省XX市XX支行」格式填寫',
    please_upload_bank_pic          : '請上傳銀行卡照片',

    account_hkbank_title            : '海外銀行賬戶',
    account_hkbank_subtitle_1       : '賬戶信息',
    country                         : '國家/地區',
    bank                            : '銀行',
    bank_code                       : '銀行代碼',
    bank_address                    : '銀行地址',
    account_name                    : '賬戶名',
    account_address                 : '賬戶地址',

    account_usdt_title              : 'USDT',
    account_usdt_subtitle_1         : '賬戶信息',
    main_network_type               : '主網類型',
    address                         : '地址',

    open_account_success_remark     : '预审一般在1-2个工作日内完成，请耐心等待！',

    examing                         : '審核中',
    exam_no_pass                    : '審核未通過',

    to_edit                         : '去修改',
    to_upload                       : '去上傳',
    to_download                     : '去下載',

    all_loaded                      : '已加載全部',
    loading                         : '加載中...',
    submit                          : '提交',

    deposit_notice_check            : '通知查收',
    deposit_info                    : '入金信息',
    deposit_amount                  : '入金金額',
    deposit_method                  : '入金方式',
    current_status                  : '當前狀態',
    cancel_reason                   : '取消原因',
    submit_date                     : '提交日期',
    transfer_info                   : '轉賬信息',
    receipt_upload                  : '回單上傳',
    deposit_store                   : '存入',
    receipt_upload_tip              : '* 請確保我司收到的實際到賬金額與填寫的入金金額一緻。',
    confirm_upload_receipt          : '確認上傳回單',
    cancel_deposit                  : '取消入金',
    cancel_deposit_tip              : '您確定要取消入金嗎？',
    cancel_deposit_success          : '入金已成功取消',
    deposit_record                  : '入金記錄',
    deposit_tip                     : '入金小貼士',
    deposit_method_tip              : '入金説明',
    deposit_amount_limit            : '入金限額',
    deposit_amount_min              : '最低入金',
    deposit_amount_max              : '最高入金',
    deposit_amount_rule             : '入金金額，支持小數點后三位',

    please_upload_receipt_pic       : '請上傳回單照片',

    upload_receipt_notice           : '您確定要提交入金回單嗎？',
    upload_receipt_success          : '回單上傳成功，請等待工作人員審核',
    deposit_no_upload_tip           : '您當權尚有入金申請未上傳轉賬回單，是否前往上傳？',


    my_invite_code                  : '我的邀請碼',
    click_copy                      : '點擊複製',
    copy_link                       : '複製鏈接',
    save_image                      : '保存圖片',
    get_image_fail                  : '獲取圖片失敗',

    share_title                     : '邀請好友 加入我們',
    share_subtitle                  : '高速行情 交易更快一點點',

    invite_join_zydf                : '邀請您加入東方',

    invite_title                    : '東方',
    invite_subtitle                 : '高速行情 洞悉市場',

    invite_register_success         : '恭喜您，註冊成功！',
    invite_click_download_app       : '您現在可以點擊下方按鈕下載APP',   

    download_ios                    : 'iPhone版下載',
    download_android                : 'Android版下載',

    id_photo                        : '證件照片',
    nationality                     : '民族',
    issuing_authority               : '簽發機關',
    validity_period                 : '有效期',
    id_information_incorrect        : '身份信息不正確？點此修改',
    other_information               : '其它信息',
    marital_status                  : '婚姻狀況',
    e_mail                          : '電子郵件',
    please_fill_in_the_email        : '請填寫電子郵件',
    please_fill_verification_code   : '請填寫驗證碼',
    please_enter_correct_email      : '請輸入正確格式電子郵件',
    please_select_marital_status    : '請選擇婚姻狀況',
    please_fill_correct_vcode       : '請填寫正確格式的驗證碼',
    to                              : ' 至 ',

    wrong_amount_minimum_deposit    : '金額錯誤，最低入金',
    wrong_amount_maximum_deposit    : '金額錯誤，最高入金',
    submit_a_deposit_application    : '您確定要提交入金申請嗎？',
    the_deposit_successfully        : '入金申請已成功提交，請盡快上傳轉賬回單進行確認。',

    submitted_successfully_wait     : '提交成功，請等待系統處理',
    web_app_download                : '東方證券理財版APP下載',

    no_more_records                 : '暫無更多記錄',
    to_be_processed                 : '待處理',
    processed                       : '已處理',

    feedback                        : '意見反饋',
    title                           : '標題',
    please_enter_a_feedback_title   : '請輸入反饋標題',
    detailed_description            : '詳細描述',
    please_enter_description        : '請輸入詳細描述',
    feedback_successfully_submitted : '意見反饋已成功提交',
    status                          : '狀態',
    process_result                  : '處理結果',

    overview                        : '概況',
    introduction                    : '簡介',
    rate_structure                  : '費率結構',
    subscription_rate               : '認購費率',
    subscription_amount_m           : '認購金額 (M, 含認購費)',
    management_fee                  : '管理費',
    redemption_rate                 : '贖回費率',
    application_share_n             : '申請份額持有時間 (N, 為自然日)',
    document                        : '文件',
    type                            : '類型',
    update_time                     : '更新時間',
    fund_introduction               : '基金介紹',

    helpful                         : '有幫助',
    no_help                         : '沒有幫助',
    not_click_repeatedly            : '不可重復點擊',

    growth_since                    : '成立以來漲幅',
    unit_net_value_hkd              : '單位凈值(港元)',
    remaining_quota                 : '剩余額度',
    historical_net_worth            : '歷史凈值',
    date                            : '日期',
    unit_net_value                  : '單位凈值',
    daily_change                    : '日漲跌幅',

    please_enter_the_search_keyword : '請輸入搜索關鍵詞',

    app_download                    : '東方APP下載',
    application_development         : '應用開發中，敬請期待……',

    please_enter_valid_phone_number : '請輸入正確的手機號',
    phone_is_registered             : '電話已註冊',
    phone_is_registered_download    : '您的手機號已註冊，您可以直接下載APP登錄',
    refresh_the_page                : '數據錯誤，請重新刷新頁面',

    setting_login_password          : '設置登錄密碼',
    please_fill_in_the_password     : '請填寫密碼',
    confirm                         : '確認',
    please_enter_password           : '請輸入密碼',
    please_enter_the_password_again : '請再次輸入密碼',
    passwords_please_check          : '兩次輸入的密碼不一致，請檢查',

    start_subscription              : '開始認購',
    deadline_for_subscription       : '截止認購',
    announcement_of_winning         : '公布中簽',
    grey_market                     : '暗盤交易',
    listed                          : '上市',
    basic_information               : '基本信息',
    cornerstone_investor            : '基石投資者',
    denomination                    : '名稱',
    planned_subscription_number     : '計劃認購數(股)',
    proportion                      : '占比',
    actual_number_of_subscriptions  : '實際認購數(股)',
    sponsor                         : '保薦人',
    category                        : '類別',
    underwriter                     : '承銷商',
    company_overview                : '公司概況',
    company_profile                 : '公司簡介',
    company_executives              : '公司高管',
    job_title                       : '職務',
    brief                           : '簡況',
    release_information             : '發行資料',

    login_has_expired               : '登錄已失效，請重新登錄',
    re_register                     : '重新登錄',

    previous_question               : '上一題',
    next_question                   : '下一題',
    confirm_submission              : '確認提交',
    submit_a_risk_assessment        : '您確定需要提交風險評測？',

    read_and_agree                  : '我已閱讀並同意相關',
    start_answering_questions       : '開始答題',

    assessment_results              : '根據風險測評結果，您的風險類型為',
    your_risk_type                  : '您的風險類型',
    retest                          : '重新測試',

    options                         : '選擇方式',
    withdrawal_amount               : '出金金額',
    accounts_receivable             : '收款賬戶',
    moderated                       : '等待審核',
    account_balance                 : '賬戶余額',
    amount_that_can_be_withdrawn    : '可提金額',
    amount_lock    					: '鎖定金額',
    withdrawal_record               : '出金記錄',
    please_fill_withdrawal_amount   : '請填寫出金金額',
    re_modify_the_withdrawal        : 'USDT最低出金50起，請重新修改出金金額',
    insufficient_account_balance    : '賬戶余額不足，當前余額：',
    extract_amount                  : '提取金額',
    countries                       : '國家',
    
    swift_code                      : 'SWIFT CODE',

    select_mainnet_type             : '請選擇主網類型',
    qr_code_picture                 : '二維碼圖片',
    please_enter_country            : '請填寫國家',
    please_fill_in_the_bank         : '請填寫銀行',
    please_fill_in_the_bank_address : '請填寫銀行地址',
    please_fill_in_the_account_name : '請填寫賬戶名',
    please_fill_in_the_bank_card    : '請填寫銀行卡號',
    please_fill_in_account_address  : '請填寫賬戶地址',
    please_fill_in_swift_code       : '請填寫SWIFT CODE',
    please_fill_in_the_address      : '請填寫地址',
    please_upload_a_qr_code_image   : '請上傳二維碼圖片',
    erc20                           : 'ERC20（推薦）',

    overseas_bank_card              : '境外銀行卡',
    please_confirm_address          : '請確認您的收款地址填寫無誤，我司將按照您所提供的收款地址轉出資金',
    withdrawal_successfully_submit  : '出金申請已成功提交',


    audited                         : '已審核',
    cancel                          : '已取消',
    pass                            : '審核通過，待劃款',
    not_pass                        : '審核未通過',
    debited                         : '已劃款',

    extract                         : '提取',
    withdrawal_tips                 : '出金小貼士',
    withdrawal_information          : '出金信息',
    cancel_apply                    : '取消申請',
    handling_fee                    : '手續費',
    audit_date                      : '審核日期',
    transfer_date                   : '轉賬日期',
    cancel_the_withdrawal           : '您確定要取消出金申請嗎？',
    cancelled_successfully          : '出金申請已成功取消',

    each_handling_fee               : '每筆手續費',
    total                           : '合計',
    please_select_an_account_type   : '請選擇賬戶類型',
    incorrect_minimum_withdrawal    : '金額錯誤，最低出金',
    amount_wrong_maximum_withdrawal : '金額錯誤，最高出金：',
    this_feature_is_being_improved  : '此功能正在完善中，敬請期待',
    stable_currency                 : '穩定幣',
    other_assets                    : '其他貨幣',
}

export default languages